import mailcheck from 'mailcheck';
export var emailSuggester = function emailSuggester(values, callback) {
  mailcheck.run({
    email: values[0],
    suggested: function suggested(suggestion) {
      callback("Did you mean ".concat(suggestion['full'], "?"));
    },
    empty: callback
  });
};